// Ensures the favorites store is initialized:
// once, in a centralized place and only client side

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    const favorites = useFavoritesStore()
    favorites.load()
  })
})
